import { i18n } from '@/main';
let cacheLanguage = "";
const LanguageConfig = {

  convert(text){
    return i18n.t(text);
  },
 async getCurrent() {
     // return  "en-US";
    if (!cacheLanguage) {
      try {
        cacheLanguage = await BMSService.getLanguage()
      } catch (e) {

      }
      if (!cacheLanguage) {
        cacheLanguage = "zh-CN";
      }
      if (cacheLanguage.startsWith("zh-")) {
        cacheLanguage = "zh-CN";
      } else {
        cacheLanguage = "en-US";
      }
    }
    // return  "zh-CN"
    return cacheLanguage;
   // return localStorage.getItem("I18n") ? localStorage.getItem("I18n") : "zh-CN"
  },


}
export default LanguageConfig;



// WEBPACK FOOTER //
// ./src/services/language.js